import React, { useState } from 'react';
import { useSpring, animated } from '@react-spring/web';
import './styles/sobre.css';
import PedroImage from './imgs/Pedro.jpg';
import JeffersonImage from './imgs/Jefferson.jpg';
import TopButton from './ScrollToTopButton';

function About() {
    const [zoomedImageIndex, setZoomedImageIndex] = useState(null);

    const toggleZoom = (index) => {
        setZoomedImageIndex(zoomedImageIndex === index ? null : index);
    };


    const images = [
        { src: PedroImage, firstName: 'Pedro', lastName: 'Augusto' },
        { src: JeffersonImage, firstName: 'Jefferson', lastName: 'Roberto' }
    ];

    const animationProps = useSpring({
        from: { transform: 'translateY(50%)', opacity: 0 },
        to: { transform: 'translateY(0)', opacity: 1 },
        config: { tension: 75, friction: 10 }
    });

    return (
        <div className='home'>
            <animated.div style={animationProps} className='welcomeCard'>
                <h1><span className="systems">Sobre</span> nós!</h1>
            </animated.div>
            <div className='team'>
                {images.map((image, index) => (
                    <div key={index} className='teamMember'>
                        <animated.div style={animationProps} className='teamMember'>
                            <div className='memberPhoto'>
                                <img
                                    src={image.src}
                                    alt={`${image.firstName} ${image.lastName}`}
                                    className={zoomedImageIndex === index ? 'Zoomed' : ''}
                                    onClick={() => toggleZoom(index)}
                                />
                            </div>
                            <div className='memberInfo'>
                                <h2>
                                    {image.firstName} <span className="lastName">{image.lastName}</span>
                                </h2>
                                <p className="job">
                                    <span className="green">
                                        {index === 0
                                            ? 'Frontend'
                                            : index === 1
                                                ? 'Backend'
                                                : 'Marketing'}
                                    </span>
                                    {index === 2 ? ' Design' : ' Developer'}
                                </p>
                                <p className="about">
                                    {index === 0
                                        ? 'Pedro é o principal desenvolvedor de interfaces na Devs Systems, com sólida experiência em JavaScript, ReactJS, React Native e CSS. Como arquiteto de interfaces, ele é responsável por projetar e implementar experiências de usuário que combinam alta funcionalidade e apelo visual. Pedro é hábil em transformar requisitos e conceitos em interfaces interativas e intuitivas, garantindo sempre um equilíbrio preciso entre usabilidade e estética. Seu trabalho no desenvolvimento frontend foca em criar soluções escaláveis e responsivas, assegurando que cada projeto não apenas atenda, mas supere as expectativas dos usuários finais.'
                                        : index === 1
                                            ? 'Jefferson é o engenheiro responsável pelas operações críticas na Devs Systems, com ampla experiência em Python e Flask. Ele projeta e implementa sistemas robustos e escaláveis, desempenhando um papel crucial para garantir que nossas APIs operem com alta eficiência, mantendo a performance e a segurança em níveis ideais. Jefferson possui um talento notável para o design de sistemas e a otimização de processos, convertendo requisitos complexos em soluções práticas e eficazes.'
                                            : ''}  {/* aqui precisa do ":" e algum valor padrão */}
                                </p>
                            </div>
                        </animated.div>
                    </div>
                ))}
            </div>
            <TopButton />
        </div>
    );
}

export default About;
